export default "__VITE_ASSET__d84c13f7__"